(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pursuit-owner-guide"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('.pog');
  if (!root) return;

  // Smooth-scroll for in-page anchors (respects sticky header via scroll-margin-top)
  root.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a) return;
    var id = a.getAttribute('href').slice(1);
    if (!id) return;
    var target = document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (history.replaceState) history.replaceState(null, '', '#' + id);
  });

  // Click-to-load YouTube facade
  var ytWrap = root.querySelector('#yt-wrap');
  if (ytWrap) {
    ytWrap.addEventListener('click', function () {
      var id = root.getAttribute('data-yt');
      var iframe = document.createElement('iframe');
      iframe.style.cssText = 'width:100%;height:100%;border:0;';
      iframe.src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1';
      iframe.title = 'FORMULA Pursuit Quick Start';
      iframe.allow = 'autoplay; encrypted-media';
      iframe.allowFullscreen = true;
      ytWrap.innerHTML = '';
      ytWrap.appendChild(iframe);
    }, { once: true });
  }

  // Active section highlight in nav
  var navLinks = root.querySelectorAll('.nav-lnk[data-section]');
  var sections = root.querySelectorAll('section[id]');

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var id = entry.target.id;
        navLinks.forEach(function (l) {
          l.classList.toggle('is-active', l.getAttribute('href') === '#' + id);
        });
      }
    });
  }, { rootMargin: '-10% 0px -72% 0px', threshold: 0 });
  sections.forEach(function (s) { io.observe(s); });

  // Keep the active nav chip scrolled into view
  var mutObs = new MutationObserver(function () {
    var active = root.querySelector('.nav-lnk.is-active');
    if (active) active.scrollIntoView({ block: 'nearest', inline: 'center' });
  });
  navLinks.forEach(function (l) {
    mutObs.observe(l, { attributes: true, attributeFilter: ['class'] });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
